module.exports = __webpack_public_path__ + "img/viessmann-connection-3.8b458d1e.png";